import { atom } from 'jotai';
import { DashboardFilterTypes } from './dashboardFilterTypes';

const defaultFilter: DashboardFilterTypes = {
  activePage: 1,
  addJobInfo: true,
  afterEndDate: false,
  beforeStartDate: false,
  itemsPerPage: 50,
  jobId: null,
  jobStatuses: ['ANY'],
  jobsOwner: 'ALL_JOBS',
  workflowNames: null,
};

export const dashboardFilterAtom = atom<DashboardFilterTypes>(defaultFilter);

export const isMyJobsOnlyAtom = atom((get) => {
  const filters = get(dashboardFilterAtom);
  return filters.jobsOwner === 'USER_JOBS';
});

export const dashboardFilterChangeTrackerAtom = atom((get) => {
  const filters = get(dashboardFilterAtom);
  return {
    afterEndDate: filters.afterEndDate,
    beforeStartDate: filters.beforeStartDate,
    itemsPerPage: filters.itemsPerPage,
    jobId: filters.jobId,
    jobStatuses: filters.jobStatuses,
    jobsOwner: filters.jobsOwner,
    workflowNames: filters.workflowNames,
  };
});
